<template>
  <div ref="root" class="sp-tab" :class="classModifiers" part="base">
    <sp-button variant="text" :color="buttonColor" part="activator">
      <slot />
    </sp-button>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";

import { useExpose } from "../../composables/expose";
import { toBoolean } from "../../utils/props";

const emit = defineEmits(["update-active"]);

const props = defineProps({
  panel: {
    type: String,
    required: true,
  },
  active: {
    type: [Boolean, String],
    default: false,
  },
});

const root = ref(null);
const { exposeProperties } = useExpose(root);

const isActive = computed(() => toBoolean(props.active));

const classModifiers = computed(() => ({
  "--is-active": isActive.value,
}));

const buttonColor = computed(() => (isActive.value ? "primary" : "default"));

watch(isActive, (value) => {
  emit("update-active", value);
});

exposeProperties({
  panel: () => props.panel,
  active: () => isActive.value,
});
</script>

<style>
:host {
  display: block;
}
</style>

<style scoped lang="scss">
.sp-tab {
  --sp-comp-button-border-radius: var(--sp-comp-tab-button-border-radius, 0);
  --sp-comp-button-text-color: var(--sp-comp-tab-button-text-color, #aaa);
  --sp-comp-button-default-hover-text-color: var(--sp-sys-color-primary);
}
</style>
